export const buyAtFixedPrice = async (
  metaspaceNFTMarketplaceContract,
  address,
  token
) => {
  const tx = await metaspaceNFTMarketplaceContract.buyAtFixedPrice(
    address,
    token
  );
  const rec = tx.wait(1);
  return rec;
};

export const maticBuyAtFixedPrice = async (
  metaspaceNFTMarketplaceContract,
  address,
  token,
  maticvalue
) => {
  console.log("maticvalue", maticvalue);
  // console.log("contract", address, token);
  const tx = await metaspaceNFTMarketplaceContract.buyAtFixedPrice(
    address,
    token,
    {
      value: maticvalue,
    }
  );
  const rec = tx.wait(1);
  return rec;
};
